import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const getCompanies = async (setData, name, page, size) => {
  return await axios.get(`companies/search-page?name=${encodeURIComponent(name)}&page=${page}&size=${size}`)
    .then((response) => {
      setData(response.data.data);
    })
    .catch(() => {});
};

export default getCompanies;